import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchMeetupspagelist = async () => {
  try {
    const response = await fetch(`${API_URL}/upcoming_meetupslist`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("Meetupslist API Error:", error);
    return null;
  }
};
